import React, { useState } from "react";
import CustomButton from "../../Components/Reusable/Button/CustomButton";
import {
  UpdateSiteTitle,
  UpdateSiteContactDetails,
  UpdateSiteBusinessHours
} from "./Requests";
import "./BusinessInfo.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifyError, notifySuccess, notifyWarn } from "../../Response/ResposeHandler";
import { useTranslation } from "react-i18next";

const BusinessInfo = (props) => {
  const { t } = useTranslation("miniSiteBusinessInfo");

  const [siteTitle, setSiteTitle] = useState(props.site.siteTitle);
  const [addressNameNumber, setAddressNameNumber] = useState(props.site.addressNumberName);
  const [addressFirstLine, setAddressFirstLine] = useState(props.site.addressFirstLine);
  const [addressSecondLine, setAddressSecondLine] = useState(props.site.addressSecondLine);
  const [addressCity, setAddressCity] = useState(props.site.addressCity);
  const [addressCounty, setAddressCounty] = useState(props.site.addressCounty);
  const [addressPostcode, setAddressPostcode] = useState(props.site.addressPostcode);
  const [phoneNumber, setPhoneNumber] = useState(props.site.phoneNumber);
  const [emailAddress, setEmailAddress] = useState(props.site.email);

  const [sundayOpen, setSundayOpen] = useState(props.site.sundayOpen !== null);
  const [sundayOpenTime, setSundayOpenTime] = useState(
    props.site.sundayOpen !== null ? { hour: props.site.sundayOpen.hour, mins: props.site.sundayOpen.mins } : { hour: null, mins: null }
  );
  const [sundayCloseTime, setSundayCloseTime] = useState(
    props.site.sundayClose !== null ? { hour: props.site.sundayClose.hour, mins: props.site.sundayClose.mins } : { hour: null, mins: null }
  );

  const [mondayOpen, setMondayOpen] = useState(props.site.mondayOpen !== null);
  const [mondayOpenTime, setMondayOpenTime] = useState(
    props.site.mondayOpen !== null ? { hour: props.site.mondayOpen.hour, mins: props.site.mondayOpen.mins } : { hour: null, mins: null }
  );
  const [mondayCloseTime, setMondayCloseTime] = useState(
    props.site.mondayClose !== null ? { hour: props.site.mondayClose.hour, mins: props.site.mondayClose.mins } : { hour: null, mins: null }
  );

  const [tuesdayOpen, setTuesdayOpen] = useState(props.site.tuesdayOpen !== null);
  const [tuesdayOpenTime, setTuesdayOpenTime] = useState(
    props.site.tuesdayOpen !== null ? { hour: props.site.tuesdayOpen.hour, mins: props.site.tuesdayOpen.mins } : { hour: null, mins: null }
  );
  const [tuesdayCloseTime, setTuesdayCloseTime] = useState(
    props.site.tuesdayClose !== null ? { hour: props.site.tuesdayClose.hour, mins: props.site.tuesdayClose.mins } : { hour: null, mins: null }
  );

  const [wednesdayOpen, setWednesdayOpen] = useState(props.site.wednesdayOpen !== null);
  const [wednesdayOpenTime, setWednesdayOpenTime] = useState(
    props.site.wednesdayOpen !== null ? { hour: props.site.wednesdayOpen.hour, mins: props.site.wednesdayOpen.mins } : { hour: null, mins: null }
  );
  const [wednesdayCloseTime, setWednesdayCloseTime] = useState(
    props.site.wednesdayClose !== null ? { hour: props.site.wednesdayClose.hour, mins: props.site.wednesdayClose.mins } : { hour: null, mins: null }
  );

  const [thursdayOpen, setThursdayOpen] = useState(props.site.thursdayOpen !== null);
  const [thursdayOpenTime, setThursdayOpenTime] = useState(
    props.site.thursdayOpen !== null ? { hour: props.site.thursdayOpen.hour, mins: props.site.thursdayOpen.mins } : { hour: null, mins: null }
  );
  const [thursdayCloseTime, setThursdayCloseTime] = useState(
    props.site.thursdayClose !== null ? { hour: props.site.thursdayClose.hour, mins: props.site.thursdayClose.mins } : { hour: null, mins: null }
  );

  const [fridayOpen, setFridayOpen] = useState(props.site.fridayOpen !== null);
  const [fridayOpenTime, setFridayOpenTime] = useState(
    props.site.fridayOpen !== null ? { hour: props.site.fridayOpen.hour, mins: props.site.fridayOpen.mins } : { hour: null, mins: null }
  );
  const [fridayCloseTime, setFridayCloseTime] = useState(
    props.site.fridayClose !== null ? { hour: props.site.fridayClose.hour, mins: props.site.fridayClose.mins } : { hour: null, mins: null }
  );

  const [saturdayOpen, setSaturdayOpen] = useState(props.site.saturdayOpen !== null);
  const [saturdayOpenTime, setSaturdayOpenTime] = useState(
    props.site.saturdayOpen !== null ? { hour: props.site.saturdayOpen.hour, mins: props.site.saturdayOpen.mins } : { hour: null, mins: null }
  );
  const [saturdayCloseTime, setSaturdayCloseTime] = useState(
    props.site.saturdayClose !== null ? { hour: props.site.saturdayClose.hour, mins: props.site.saturdayClose.mins } : { hour: null, mins: null }
  );

  const errorsOpeningHoursObj = {
    sundayOpen: "",
    sundayClose: "",
    mondayOpen: "",
    mondayClose: "",
    tuesdayOpen: "",
    tuesdayClose: "",
    wednesdayOpen: "",
    wednesdayClose: "",
    thursdayOpen: "",
    thursdayClose: "",
    fridayOpen: "",
    fridayClose: "",
    saturdayOpen: "",
    saturdayClose: ""
  };
  const [openingHoursErrors, setOpeningHoursErrors] = useState(errorsOpeningHoursObj);

  const errorsInfoObj = { NameNumber: "", firstLine: "", secondLine: "", city: "", county: "", mobile: "", postcode: "" };
  const [infoErrors, setInfoErrors] = useState(errorsInfoObj);
  const [siteTitleError, setSiteTitleError] = useState("");

  const [siteTitleButtonLoading, setSiteTitleButtonLoading] = useState(false);
  const [contactButtonLoading, setContactButtonLoading] = useState(false);
  const [businessHoursButtonLoading, setBusinessHoursButtonLoading] = useState(false);

  const [showBusinessHours, setShowBusinessHours] = useState(props.site.showBusinessHours);

  function TimeHandler(value, option, setFn, obj) {
    if (option === "openHour") setFn({ hour: value, mins: obj.mins });
    if (option === "openMins") setFn({ hour: obj.hour, mins: value });
    if (option === "closeHour") setFn({ hour: value, mins: obj.mins });
    if (option === "closeMins") setFn({ hour: obj.hour, mins: value });
  }

  function validateDay(openFlag, openTime, closeTime, dayKey, errs) {
    if (!openFlag) return;
    const invalidOpen =
      openTime == null ||
      openTime.hour == null ||
      openTime.mins == null ||
      openTime.hour < 0 ||
      openTime.hour > 23 ||
      openTime.mins < 0 ||
      openTime.mins > 59;
    const invalidClose =
      closeTime == null ||
      closeTime.hour == null ||
      closeTime.mins == null ||
      closeTime.hour < 0 ||
      closeTime.hour > 23 ||
      closeTime.mins < 0 ||
      closeTime.mins > 59;

    if (invalidOpen) errs[`${dayKey}Open`] = t("errors.openInvalid", { day: t(`days.${dayKey}`) });
    if (invalidClose) errs[`${dayKey}Close`] = t("errors.closeInvalid", { day: t(`days.${dayKey}`) });
  }

  function SubmitOpenHours() {
    let err = false;
    const next = { ...errorsOpeningHoursObj };

    if (showBusinessHours) {
      validateDay(sundayOpen, sundayOpenTime, sundayCloseTime, "sunday", next);
      validateDay(mondayOpen, mondayOpenTime, mondayCloseTime, "monday", next);
      validateDay(tuesdayOpen, tuesdayOpenTime, tuesdayCloseTime, "tuesday", next);
      validateDay(wednesdayOpen, wednesdayOpenTime, wednesdayCloseTime, "wednesday", next);
      validateDay(thursdayOpen, thursdayOpenTime, thursdayCloseTime, "thursday", next);
      validateDay(fridayOpen, fridayOpenTime, fridayCloseTime, "friday", next);
      validateDay(saturdayOpen, saturdayOpenTime, saturdayCloseTime, "saturday", next);
    }

    Object.values(next).forEach((v) => {
      if (v) err = true;
    });

    setOpeningHoursErrors(next);

    if (!err) {
      setBusinessHoursButtonLoading(true);
      UpdateSiteBusinessHours(
        showBusinessHours,
        sundayOpenTime,
        sundayCloseTime,
        mondayOpenTime,
        mondayCloseTime,
        tuesdayOpenTime,
        tuesdayCloseTime,
        wednesdayOpenTime,
        wednesdayCloseTime,
        thursdayOpenTime,
        thursdayCloseTime,
        fridayOpenTime,
        fridayCloseTime,
        saturdayOpenTime,
        saturdayCloseTime
      )
        .then(() => {
          notifySuccess(t("toasts.hoursSaved"));
        })
        .catch(() => {
          notifyError(t("toasts.genericError"));
        })
        .finally(() => {
          props.getSite?.();
          setBusinessHoursButtonLoading(false);
        });
    } else {
      notifyWarn(t("toasts.checkHours"));
    }
  }

  function SubmitSiteTitle() {
    if (!siteTitle) {
      notifyWarn(t("toasts.siteTitleMissing"));
      setSiteTitleError(t("errors.invalidSiteTitle"));
    } else {
      setSiteTitleError("");
      setSiteTitleButtonLoading(true);
      UpdateSiteTitle(siteTitle)
        .then(() => {
          notifySuccess(t("toasts.siteTitleSaved"));
        })
        .catch(() => {
          notifyError(t("toasts.genericError"));
        })
        .finally(() => {
          setSiteTitleButtonLoading(false);
          props.getSite?.();
        });
    }
  }

  function SubmitContactDetails() {
    let error = false;
    const ei = { ...errorsInfoObj };

    const nothingEntered =
      !addressNameNumber &&
      !addressFirstLine &&
      !addressSecondLine &&
      !addressCity &&
      !addressCounty &&
      !addressPostcode &&
      !phoneNumber &&
      !emailAddress;

    if (!nothingEntered) {
      const noAddressButHasContact =
        !addressNameNumber &&
        !addressFirstLine &&
        !addressSecondLine &&
        !addressCity &&
        !addressCounty &&
        !addressPostcode &&
        (phoneNumber || emailAddress);

      if (!noAddressButHasContact) {
        if (!addressNameNumber) {
          ei.NameNumber = t("errors.addressNameNumber");
          error = true;
        }
        if (!addressFirstLine) {
          ei.firstLine = t("errors.addressFirstLine");
          error = true;
        }
        if (!addressCity) {
          ei.city = t("errors.addressCity");
          error = true;
        }
        if (!addressPostcode) {
          ei.postcode = t("errors.addressPostcode");
          error = true;
        }
      }
    }

    if (error) {
      notifyWarn(t("toasts.checkContact"));
    }

    setInfoErrors(ei);
    if (!error) {
      setContactButtonLoading(true);
      UpdateSiteContactDetails(
        addressNameNumber,
        addressFirstLine,
        addressSecondLine,
        addressCity,
        addressCounty,
        addressPostcode,
        phoneNumber,
        emailAddress
      )
        .then(() => {
          notifySuccess(t("toasts.contactSaved"));
        })
        .catch(() => {
          notifyError(t("toasts.genericError"));
        })
        .finally(() => {
          props.getSite?.();
          setContactButtonLoading(false);
        });
    }
  }

  function businessDayHandler(e, setFlag) {
    setFlag(e.target.checked);
    if (!e.target.checked) {
      const id = e.target.id;
      if (id === "sundayCheck") {
        setSundayOpenTime({ hour: null, mins: null });
        setSundayCloseTime({ hour: null, mins: null });
      }
      if (id === "mondayCheck") {
        setMondayOpenTime({ hour: null, mins: null });
        setMondayCloseTime({ hour: null, mins: null });
      }
      if (id === "tuesdayCheck") {
        setTuesdayOpenTime({ hour: null, mins: null });
        setTuesdayCloseTime({ hour: null, mins: null });
      }
      if (id === "wednesdayCheck") {
        setWednesdayOpenTime({ hour: null, mins: null });
        setWednesdayCloseTime({ hour: null, mins: null });
      }
      if (id === "thursdayCheck") {
        setThursdayOpenTime({ hour: null, mins: null });
        setThursdayCloseTime({ hour: null, mins: null });
      }
      if (id === "fridayCheck") {
        setFridayOpenTime({ hour: null, mins: null });
        setFridayCloseTime({ hour: null, mins: null });
      }
      if (id === "saturdayCheck") {
        setSaturdayOpenTime({ hour: null, mins: null });
        setSaturdayCloseTime({ hour: null, mins: null });
      }
    }
  }

  return (
    <div className="info-wrap">
      <ToastContainer />

      {/* SITE TITLE */}
      <section className="sm-card">
        <div className="gen-cardHead">
          <h3 className="gen-h3">
            {t("titles.siteTitle")}
            <span className="sm-req">*</span>
          </h3>
          <p className="sm-sub">{t("subtitles.siteTitle")}</p>
        </div>

        <div className="sm-form sm-grid sm-grid--2-1">
          <div className="sm-field">
            <input
              id="site-title"
              type="text"
              className="sm-input"
              maxLength={40}
              required
              value={siteTitle}
              onChange={(e) => setSiteTitle(e.target.value)}
              placeholder={t("placeholders.businessName")}
              aria-label={t("labels.siteTitle")}
            />
            {siteTitleError && <div className="sm-error">{siteTitleError}</div>}
          </div>

          <div className="infoActions">
            <CustomButton
              disabled={siteTitleButtonLoading}
              className="app-btn--sm"
              onClick={SubmitSiteTitle}
              label={t("actions.save")}
              loading={siteTitleButtonLoading}
            />
          </div>
        </div>
      </section>

      {/* ADDRESS / CONTACT */}
      <section className="sm-card">
        <div className="gen-cardHead mb-4">
          <h3 className="gen-h3">{t("titles.addressContact")}</h3>
          <p className="sm-sub">{t("subtitles.addressContact")}</p>
        </div>

        <div className="sm-form sm-grid sm-grid--2">
          <div className="sm-field">
            <label className="sm-label" htmlFor="address-number-name">
              {t("labels.number")}
            </label>
            <input
              id="address-number-name"
              className="sm-input"
              type="text"
              maxLength={45}
              value={addressNameNumber}
              onChange={(e) => setAddressNameNumber(e.target.value)}
              placeholder={t("placeholders.number")}
            />
            {infoErrors.NameNumber && <div className="sm-error">{infoErrors.NameNumber}</div>}
          </div>

          <div className="sm-field">
            <label className="sm-label" htmlFor="address-first-line">
              {t("labels.firstLine")}
            </label>
            <input
              id="address-first-line"
              className="sm-input"
              type="text"
              maxLength={45}
              value={addressFirstLine}
              onChange={(e) => setAddressFirstLine(e.target.value)}
              placeholder={t("placeholders.address1")}
            />
            {infoErrors.firstLine && <div className="sm-error">{infoErrors.firstLine}</div>}
          </div>

          <div className="sm-field">
            <label className="sm-label" htmlFor="address-second-line">
              {t("labels.secondLine")}
            </label>
            <input
              id="address-second-line"
              className="sm-input"
              type="text"
              maxLength={45}
              value={addressSecondLine}
              onChange={(e) => setAddressSecondLine(e.target.value)}
              placeholder={t("placeholders.address2")}
            />
            {infoErrors.secondLine && <div className="sm-error">{infoErrors.secondLine}</div>}
          </div>

          <div className="sm-field">
            <label className="sm-label" htmlFor="address-city">
              {t("labels.city")}
            </label>
            <input
              id="address-city"
              className="sm-input"
              type="text"
              maxLength={45}
              value={addressCity}
              onChange={(e) => setAddressCity(e.target.value)}
              placeholder={t("placeholders.city")}
            />
            {infoErrors.city && <div className="sm-error">{infoErrors.city}</div>}
          </div>

          <div className="sm-field">
            <label className="sm-label" htmlFor="address-county">
              {t("labels.county")}
            </label>
            <input
              id="address-county"
              className="sm-input"
              type="text"
              maxLength={45}
              value={addressCounty}
              onChange={(e) => setAddressCounty(e.target.value)}
              placeholder={t("placeholders.county")}
            />
            {infoErrors.county && <div className="sm-error">{infoErrors.county}</div>}
          </div>

          <div className="sm-field">
            <label className="sm-label" htmlFor="address-postcode">
              {t("labels.postcode")}
            </label>
            <input
              id="address-postcode"
              className="sm-input"
              type="text"
              value={addressPostcode}
              onChange={(e) => setAddressPostcode(e.target.value)}
              placeholder={t("placeholders.postcode")}
            />
            {infoErrors.postcode && <div className="sm-error">{infoErrors.postcode}</div>}
          </div>

          <div className="sm-field">
            <label className="sm-label" htmlFor="email">
              {t("labels.email")} <span className="sm-help">{t("hints.clientFacing")}</span>
            </label>
            <input
              id="email"
              className="sm-input"
              type="email"
              maxLength={45}
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              placeholder={t("placeholders.email")}
            />
          </div>

          <div className="sm-field">
            <label className="sm-label" htmlFor="tel">
              {t("labels.phone")} <span className="sm-help">{t("hints.clientFacing")}</span>
            </label>
            <input
              id="tel"
              className="sm-input"
              type="tel"
              maxLength={12}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder={t("placeholders.phone")}
            />
            {infoErrors.mobile && <div className="sm-error">{infoErrors.mobile}</div>}
          </div>
        </div>

        <div className="infoActions mt-3">
          <CustomButton
            disabled={contactButtonLoading}
            className="app-btn--sm"
            onClick={SubmitContactDetails}
            label={t("actions.save")}
            loading={contactButtonLoading}
          />
        </div>
      </section>

      {/* OPENING HOURS */}
      <section className="sm-card">
        <div className="gen-cardHead mb-4">
          <h3 className="gen-h3">{t("titles.openingHours")}</h3>
          <p className="sm-sub">{t("subtitles.openingHours")}</p>
        </div>

        <div className="oh-toggle">
          <label className="oh-switch">
            <input
              type="checkbox"
              defaultChecked={showBusinessHours}
              onChange={(e) => setShowBusinessHours(e.target.checked)}
            />
            <span className="oh-slider" />
            <span className="oh-label">{t("toggles.showOpeningHours")}</span>
          </label>
        </div>

        {showBusinessHours && (
          <div className="oh-list oh-list--fluid">
            {/* Monday */}
            <div className="oh-row oh-row--stack">
              <label className="oh-day">
                <input
                  type="checkbox"
                  id="mondayCheck"
                  defaultChecked={mondayOpen}
                  onChange={(e) => businessDayHandler(e, setMondayOpen)}
                />
                <span>{t("days.monday")}</span>
              </label>
              {!mondayOpen ? (
                <div>
                  <p className="sm-sub mb-2" style={{ marginLeft: "2rem" }}>
                    {t("common.closed")}
                  </p>
                </div>
              ) : (
                <div className="oh-times">
                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!mondayOpen}
                      value={mondayOpenTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openHour", setMondayOpenTime, mondayOpenTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!mondayOpen}
                      value={mondayOpenTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openMins", setMondayOpenTime, mondayOpenTime)
                      }
                    />
                  </div>

                  <span className="oh-dash">–</span>

                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!mondayOpen}
                      value={mondayCloseTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeHour", setMondayCloseTime, mondayCloseTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!mondayOpen}
                      value={mondayCloseTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeMins", setMondayCloseTime, mondayCloseTime)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {openingHoursErrors.mondayOpen && <div className="sm-error">{openingHoursErrors.mondayOpen}</div>}
            {openingHoursErrors.mondayClose && <div className="sm-error">{openingHoursErrors.mondayClose}</div>}

            {/* Tuesday */}
            <div className="oh-row oh-row--stack">
              <label className="oh-day">
                <input
                  type="checkbox"
                  id="tuesdayCheck"
                  defaultChecked={tuesdayOpen}
                  onChange={(e) => businessDayHandler(e, setTuesdayOpen)}
                />
                <span>{t("days.tuesday")}</span>
              </label>
              {!tuesdayOpen ? (
                <div>
                  <p className="sm-sub mb-2" style={{ marginLeft: "2rem" }}>
                    {t("common.closed")}
                  </p>
                </div>
              ) : (
                <div className="oh-times">
                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!tuesdayOpen}
                      value={tuesdayOpenTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openHour", setTuesdayOpenTime, tuesdayOpenTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!tuesdayOpen}
                      value={tuesdayOpenTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openMins", setTuesdayOpenTime, tuesdayOpenTime)
                      }
                    />
                  </div>

                  <span className="oh-dash">–</span>

                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!tuesdayOpen}
                      value={tuesdayCloseTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeHour", setTuesdayCloseTime, tuesdayCloseTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!tuesdayOpen}
                      value={tuesdayCloseTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeMins", setTuesdayCloseTime, tuesdayCloseTime)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {openingHoursErrors.tuesdayOpen && <div className="sm-error">{openingHoursErrors.tuesdayOpen}</div>}
            {openingHoursErrors.tuesdayClose && <div className="sm-error">{openingHoursErrors.tuesdayClose}</div>}

            {/* Wednesday */}
            <div className="oh-row oh-row--stack">
              <label className="oh-day">
                <input
                  type="checkbox"
                  id="wednesdayCheck"
                  defaultChecked={wednesdayOpen}
                  onChange={(e) => businessDayHandler(e, setWednesdayOpen)}
                />
                <span>{t("days.wednesday")}</span>
              </label>
              {!wednesdayOpen ? (
                <div>
                  <p className="sm-sub mb-2" style={{ marginLeft: "2rem" }}>
                    {t("common.closed")}
                  </p>
                </div>
              ) : (
                <div className="oh-times">
                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!wednesdayOpen}
                      value={wednesdayOpenTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openHour", setWednesdayOpenTime, wednesdayOpenTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!wednesdayOpen}
                      value={wednesdayOpenTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openMins", setWednesdayOpenTime, wednesdayOpenTime)
                      }
                    />
                  </div>

                  <span className="oh-dash">–</span>

                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!wednesdayOpen}
                      value={wednesdayCloseTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeHour", setWednesdayCloseTime, wednesdayCloseTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!wednesdayOpen}
                      value={wednesdayCloseTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeMins", setWednesdayCloseTime, wednesdayCloseTime)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {openingHoursErrors.wednesdayOpen && <div className="sm-error">{openingHoursErrors.wednesdayOpen}</div>}
            {openingHoursErrors.wednesdayClose && <div className="sm-error">{openingHoursErrors.wednesdayClose}</div>}

            {/* Thursday */}
            <div className="oh-row oh-row--stack">
              <label className="oh-day">
                <input
                  type="checkbox"
                  id="thursdayCheck"
                  defaultChecked={thursdayOpen}
                  onChange={(e) => businessDayHandler(e, setThursdayOpen)}
                />
                <span>{t("days.thursday")}</span>
              </label>
              {!thursdayOpen ? (
                <div>
                  <p className="sm-sub mb-2" style={{ marginLeft: "2rem" }}>
                    {t("common.closed")}
                  </p>
                </div>
              ) : (
                <div className="oh-times">
                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!thursdayOpen}
                      value={thursdayOpenTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openHour", setThursdayOpenTime, thursdayOpenTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!thursdayOpen}
                      value={thursdayOpenTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openMins", setThursdayOpenTime, thursdayOpenTime)
                      }
                    />
                  </div>

                  <span className="oh-dash">–</span>

                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!thursdayOpen}
                      value={thursdayCloseTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeHour", setThursdayCloseTime, thursdayCloseTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!thursdayOpen}
                      value={thursdayCloseTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeMins", setThursdayCloseTime, thursdayCloseTime)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {openingHoursErrors.thursdayOpen && <div className="sm-error">{openingHoursErrors.thursdayOpen}</div>}
            {openingHoursErrors.thursdayClose && <div className="sm-error">{openingHoursErrors.thursdayClose}</div>}

            {/* Friday */}
            <div className="oh-row oh-row--stack">
              <label className="oh-day">
                <input
                  type="checkbox"
                  id="fridayCheck"
                  defaultChecked={fridayOpen}
                  onChange={(e) => businessDayHandler(e, setFridayOpen)}
                />
                <span>{t("days.friday")}</span>
              </label>
              {!fridayOpen ? (
                <div>
                  <p className="sm-sub mb-2" style={{ marginLeft: "2rem" }}>
                    {t("common.closed")}
                  </p>
                </div>
              ) : (
                <div className="oh-times">
                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!fridayOpen}
                      value={fridayOpenTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openHour", setFridayOpenTime, fridayOpenTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!fridayOpen}
                      value={fridayOpenTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openMins", setFridayOpenTime, fridayOpenTime)
                      }
                    />
                  </div>

                  <span className="oh-dash">–</span>

                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!fridayOpen}
                      value={fridayCloseTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeHour", setFridayCloseTime, fridayCloseTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!fridayOpen}
                      value={fridayCloseTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeMins", setFridayCloseTime, fridayCloseTime)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {openingHoursErrors.fridayOpen && <div className="sm-error">{openingHoursErrors.fridayOpen}</div>}
            {openingHoursErrors.fridayClose && <div className="sm-error">{openingHoursErrors.fridayClose}</div>}

            {/* Saturday */}
            <div className="oh-row oh-row--stack">
              <label className="oh-day">
                <input
                  type="checkbox"
                  id="saturdayCheck"
                  defaultChecked={saturdayOpen}
                  onChange={(e) => businessDayHandler(e, setSaturdayOpen)}
                />
                <span>{t("days.saturday")}</span>
              </label>
              {!saturdayOpen ? (
                <div>
                  <p className="sm-sub mb-2" style={{ marginLeft: "2rem" }}>
                    {t("common.closed")}
                  </p>
                </div>
              ) : (
                <div className="oh-times">
                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!saturdayOpen}
                      value={saturdayOpenTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openHour", setSaturdayOpenTime, saturdayOpenTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!saturdayOpen}
                      value={saturdayOpenTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openMins", setSaturdayOpenTime, saturdayOpenTime)
                      }
                    />
                  </div>

                  <span className="oh-dash">–</span>

                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!saturdayOpen}
                      value={saturdayCloseTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeHour", setSaturdayCloseTime, saturdayCloseTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!saturdayOpen}
                      value={saturdayCloseTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeMins", setSaturdayCloseTime, saturdayCloseTime)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {openingHoursErrors.saturdayOpen && <div className="sm-error">{openingHoursErrors.saturdayOpen}</div>}
            {openingHoursErrors.saturdayClose && <div className="sm-error">{openingHoursErrors.saturdayClose}</div>}

            {/* Sunday */}
            <div className="oh-row oh-row--stack">
              <label className="oh-day">
                <input
                  type="checkbox"
                  id="sundayCheck"
                  defaultChecked={sundayOpen}
                  onChange={(e) => businessDayHandler(e, setSundayOpen)}
                />
                <span>{t("days.sunday")}</span>
              </label>
              {!sundayOpen ? (
                <div>
                  <p className="sm-sub mb-2" style={{ marginLeft: "2rem" }}>
                    {t("common.closed")}
                  </p>
                </div>
              ) : (
                <div className="oh-times">
                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!sundayOpen}
                      value={sundayOpenTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openHour", setSundayOpenTime, sundayOpenTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!sundayOpen}
                      value={sundayOpenTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "openMins", setSundayOpenTime, sundayOpenTime)
                      }
                    />
                  </div>

                  <span className="oh-dash">–</span>

                  <div className="oh-group">
                    <input
                      type="number"
                      className="oh-time"
                      max={23}
                      min={0}
                      disabled={!sundayOpen}
                      value={sundayCloseTime.hour}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeHour", setSundayCloseTime, sundayCloseTime)
                      }
                    />
                    <span className="oh-sep">:</span>
                    <input
                      type="number"
                      className="oh-time"
                      max={59}
                      min={0}
                      disabled={!sundayOpen}
                      value={sundayCloseTime.mins}
                      onChange={(e) =>
                        TimeHandler(e.target.value, "closeMins", setSundayCloseTime, sundayCloseTime)
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {openingHoursErrors.sundayOpen && <div className="sm-error">{openingHoursErrors.sundayOpen}</div>}
            {openingHoursErrors.sundayClose && <div className="sm-error">{openingHoursErrors.sundayClose}</div>}
          </div>
        )}

        <div className="infoActions mt-3">
          <CustomButton
            disabled={businessHoursButtonLoading}
            className="app-btn--sm"
            onClick={SubmitOpenHours}
            label={t("actions.save")}
            loading={businessHoursButtonLoading}
          />
        </div>
      </section>
    </div>
  );
};

export default BusinessInfo;
